import { useState } from 'react';

import { useGetPaymentsQuery } from '@/modules/payments';
import { useShowResponseStatus } from '@/shared';

import type { TGetPayments } from '@/modules/payments/store/types';

const initialParams: TGetPayments = {
  pageSize: 30,
  page: 1,
  ascending: false,
};

export const useGetPayments = () => {
  const [params, setParams] = useState<TGetPayments>(initialParams);
  const { data, isLoading, isError } = useGetPaymentsQuery(params, {
    pollingInterval: 60000,
  });
  const itemsCount = data?.count;
  const items = data?.items ?? [];

  useShowResponseStatus({
    isError,
    errorMassage: 'Произошла ошибка!',
  });

  const handleFilterChange = (data: TGetPayments) => {
    setParams({ ...initialParams, ...data });
  };

  const handleFilterReset = () => {
    setParams({ ...initialParams });
  };

  const handlePaginationChange = (page: number) => {
    setParams((prev) => ({
      ...prev,
      page,
    }));
  };

  return {
    params,
    items,
    itemsCount,
    isLoading,
    handleFilterChange,
    handleFilterReset,
    handlePaginationChange,
  };
};
